export function unSlugify(slug) {
  const words = slug?.split('-');

  for (let i = 0; i < words.length; i++) {
    const word = words[i];
    words[i] = word.charAt(0).toUpperCase() + word.slice(1);
  }

  return words.join(' ');
}

export function getGidFromUrl(url) {
  return url.match(new RegExp('shopping/product/(.*)\\?'))?.[1];
}

export function serialize(string) {
  return string && JSON.parse(JSON.stringify(string));
}

export function capitalizeFirstLetter(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}
